import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import ReactTable, { ReactTableDefaults } from 'react-table';

import {
  ReactTableFilterDatePicker,
  ReactTableSearch,
  ReactTablePagination,
  ReactTableHeaderText,
  Loading
} from 'components';

import { Icon, Popup, Image } from 'semantic-ui-react';
import { Tooltip } from 'material-ui';

import * as common from 'libs/commonFunc';

import moment from 'moment';
import 'moment/locale/ko';
import 'moment/locale/ja';

import classNames from 'classnames/bind';
import styles from './ExamLeakFileList.css';
const cx = classNames.bind(styles);

moment.locale(localStorage.getItem('language'));

class ExamLeakFileList extends PureComponent {
  shouldComponentUpdate(nextProps, nextState) {
    if (this.props !== nextProps) {
      return true;
    }
    return false;
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    // 검색 (상단)
    const { searchObj } = this.props;
    // 필터
    const { data, fromNowView, isAuth, ...rest } = this.props;
    // 필터
    const {
      leakTypeFilter,
      cancleCheck,
      filterClose,
      executeFilter,
      onFilterCancel,
      handleChangeDateFilter
    } = this.props;
    // 현재 페이지 이동 (하단)
    const { handlePagination } = this.props;

    const columns = [
      {
        Header: <ReactTableHeaderText title={'No'} />,
        accessor: 'leakFileNo',
        sortable: true,
        resizable: false,
        width: 72,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td text-align-center number-text')
      },
      {
        Header: ({ ...rest }) => {
          const listItem = [
            {
              key: '1',
              text: defineMessages(formatMessage({ id: 'ExamLeakFileList_5', defaultMessage: 'PC파일' })),
              value: '1'
            },
            {
              key: '2',
              text: defineMessages(formatMessage({ id: 'ExamLeakFileList_2', defaultMessage: '인증서' })),
              value: '2'
            },
            {
              key: '3',
              text: defineMessages(formatMessage({ id: 'ExamLeakFileList_3', defaultMessage: '이메일' })),
              value: '3'
            }
          ];

          return (
            <ReactTableHeaderText
              title={defineMessages(formatMessage({ id: 'ExamLeakFileList_1', defaultMessage: '파일 구분' }))}
              // filter={
              //   <ReactTableFilterDropdown
              //     // isMulti
              //     listItem={listItem}
              //     filter={searchObj.filterData}
              //     handleChangeFilter={handleChangeFilter}
              //     column={rest.column.id}
              //   />
              // }
            />
          );
        },
        accessor: 'leakType',
        id: 'leakType',
        sortable: true,
        resizable: false,
        width: 110,
        headerClassName: cx('react-table-th', 'overflow-visible'),
        className: cx('react-table-td', 'text-align-center'),
        Cell: ({ value }) => {
          let printValue = '-';
          if (value === 1) {
            printValue = defineMessages(formatMessage({ id: 'ExamLeakFileList_5', defaultMessage: 'PC파일' }));
          } else if (value === 2) {
            printValue = defineMessages(formatMessage({ id: 'ExamLeakFileList_2', defaultMessage: '인증서' }));
          } else if (value === 3) {
            printValue = defineMessages(formatMessage({ id: 'ExamLeakFileList_3', defaultMessage: '이메일' }));
          } else {
            // 나머지
          }
          return printValue;
        }
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'ExamLeakFileList_6', defaultMessage: '파일명' }))}
          />
        ),
        accessor: 'fileName',
        sortable: true,
        minWidth: 261,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td'),
        Cell: ({ original }) => {
          let certObj = '';
          // 인증서 상세 정보
          if (original.leakType === 2 && typeof original.extraInfo.cert !== 'undefined') {
            const certData = original.extraInfo.cert;

            certObj = (
              <Popup
                trigger={
                  <Tooltip
                    title={defineMessages(
                      formatMessage({ id: 'ExamLeakFileList_19', defaultMessage: '인증서 상세 정보' })
                    )}
                    placement="right">
                    <Icon name="warning circle" size="tiny" className={cx('certDetail')} />
                  </Tooltip>
                }
                content={
                  <div className={cx('certDetail-popup')}>
                    <div className={cx('certDetail-title')}>
                      {defineMessages(formatMessage({ id: 'ExamLeakFileList_20', defaultMessage: '인증서 정보' }))}
                    </div>
                    <div className={cx('certDetail-content')}>{certData.subject.split(', ')[0].split('=')[1]}</div>
                    <div className={cx('certDetail-content')}>{certData.subject.split(', ')[1].split('=')[1]}</div>
                    <div className={cx('certDetail-content')}>{certData.subject.split(', ')[3].split('=')[1]}</div>
                    <div className={cx('certDetail-content')}>
                      {common.timeFormatFromUTCEpoch(certData.startEpoch, 3) +
                        ' ~ ' +
                        common.timeFormatFromUTCEpoch(certData.endEpoch, 3)}
                    </div>
                  </div>
                }
                on="click"
              />
            );
          }

          return (
            <Tooltip title={original.fullPath} placement="bottom">
              <div className={cx('cell-fileName-area')}>
                <div className={cx('file-ext-icon', 'ext-' + original.fileExt)} />
                <div className={cx('fileName-text')}>
                  {certObj}
                  {original.fileName}
                </div>
              </div>
            </Tooltip>
          );
        }
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'ExamLeakFileList_7', defaultMessage: '크기' }))}
          />
        ),
        accessor: 'fileSize',
        sortable: true,
        resizable: false,
        minWidth: 82,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-right'),
        Cell: ({ value }) => {
          return common.humanFileSize(value);
        }
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'ExamLeakFileList_8', defaultMessage: '대상자명' }))}
          />
        ),
        accessor: 'targetName',
        sortable: true,
        resizable: false,
        minWidth: 106,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td', 'text-align-center')
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'ExamLeakFileList_9', defaultMessage: '대상자 이메일' }))}
          />
        ),
        accessor: 'targetEmail',
        sortable: true,
        minWidth: 199,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td')
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'ExamLeakFileList_10', defaultMessage: 'PC' }))}
          />
        ),
        accessor: 'hostname',
        sortable: true,
        minWidth: 143,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td')
      },
      {
        Header: (
          <ReactTableHeaderText
            title={defineMessages(formatMessage({ id: 'ExamLeakFileList_11', defaultMessage: '훈련명' }))}
          />
        ),
        accessor: 'examName',
        sortable: true,
        minWidth: 193,
        headerClassName: cx('react-table-th'),
        className: cx('react-table-td sub-text')
      },
      {
        Header: ({ ...rest }) => {
          return (
            <ReactTableHeaderText
              title={defineMessages(formatMessage({ id: 'ExamLeakPCList_13', defaultMessage: '감염 일시' }))}
              filter={
                <ReactTableFilterDatePicker
                  {...rest}
                  filter={searchObj.filterData}
                  onChange={data => {
                    handleChangeDateFilter('RegEpoch', data);
                  }}
                />
              }
            />
          );
        },
        accessor: 'regEpoch',
        minWidth: 177,
        sortable: true,
        resizable: false,
        headerClassName: cx('react-table-th', 'overflow-visible'),
        className: cx('react-table-td', 'text-align-center sub-text'),
        Cell: ({ value }) => {
          const dateFormat = localStorage.getItem('language') === 'en' ? 'MM/DD/YYYY' : 'YYYY-MM-DD';
          return (
            <div>
              <span className={cx('log-reg-date-normal')}>{moment.unix(value).format(dateFormat + ' HH:mm:ss')}</span>
              <span className={cx('log-reg-date-fromnow')}>{moment.unix(value).fromNow()}</span>
            </div>
          );
        }
      }
    ];

    const { TbodyComponent: tbadyWrapper } = ReactTableDefaults;

    return (
      <div className={cx('react-table-area', fromNowView ? 'from-now-view' : '')}>
        <ReactTableSearch
          searchObj={searchObj}
          listData={data}
          //필터 영역
          filters={{
            leakTypeFilter: leakTypeFilter
          }}
          cancleCheck={cancleCheck}
          filterClose={filterClose}
          executeFilter={executeFilter}
          onFilterCancel={onFilterCancel}
        />
        <div className={cx('react-table')}>
          <ReactTable
            columns={columns}
            data={data}
            sortable={false}
            filterable={false}
            showPagination={false}
            showPageSizeOptions={false}
            defaultSorted={[
              {
                id: 'leakFileNo',
                desc: true
              }
            ]}
            loadingText={defineMessages(formatMessage({ id: 'ExamLeakPCList_16', defaultMessage: '데이터 로딩중...' }))}
            LoadingComponent={({ ...rest }) => <Loading active={rest.loading} content={rest.loadingText} />}
            FilterComponent={({ ...rest }) => <div />}
            TbodyComponent={({ ...rest }) => (
              <div style={{ ...rest.style }} className={cx('react-table-tbody-wrapper')}>
                <tbadyWrapper {...rest} className={cx('rt-tbody', rest.className ? rest.className : '')} />
              </div>
            )}
            NoDataComponent={({ ...rest }) => (
              <div className={cx('noData-area')}>
                <Image src="/img/table/nodata_icon.png" />
                {defineMessages(formatMessage({ id: 'ExamTemplateList_24', defaultMessage: '데이터가 없습니다.' }))}
              </div>
            )}
            getTheadThProps={(state, rowInfo, column) => {
              const filter = [];
              if (column) {
                // 필터 처리
                if (typeof searchObj.filterData[column.id] !== 'undefined') {
                  filter.push('isFiltered');
                }
                // 정렬 제공 안하는 header
                if (!column.sortable) {
                  filter.push('no-sort');
                }

                return filter.length > 0
                  ? {
                      className: filter.join(' ')
                    }
                  : {};
              }
            }}
            {...rest}
          />
        </div>
        <ReactTablePagination
          currentPage={rest.page}
          totalPages={rest.pages ? rest.pages : 0}
          handlePagination={handlePagination}
        />
      </div>
    );
  }
}

export default injectIntl(ExamLeakFileList);



// WEBPACK FOOTER //
// ./src/script/components/exam/ExamLeakFileList.js